// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        key: 1,
        path: '/login',
        component: 'login',
        auth: false
    },
    // {
    //     key: 2,
    //     path: '/register',
    //     component: 'register',
    //     auth: false
    // },
    {
        key: 3,
        path: '/home',
        component: 'home',
        auth: true
    },
    {
        key: 4,
        path: '/chart',
        component: 'chart',
        auth: true
    }
];
